import React from "react";
import { useTranslation } from "react-i18next";

import { Chip, Tooltip } from "@mui/material";

export default function RiskScoreChip({ row, riskColors }) {
  const { t } = useTranslation();

  const getDangerLevel = (row) => {
    if (row.risk_score_details.some((e) => e.level === "high")) return "high";
    if (row.risk_score_details.some((e) => e.level === "medium"))
      return "medium";
    return "low";
  };

  const labels = {
    high: t("riskScore.high"),
    medium: t("riskScore.medium"),
    low: t("riskScore.low"),
  };

  const dangerLevel = getDangerLevel(row);
  const formatColor = riskColors[dangerLevel];

  if (!row.last_check_date) return null;

  return (
    <>
      {formatColor && (
        <Tooltip title={labels[dangerLevel]}>
          <Chip
            size="small"
            sx={{
              color: formatColor.textColor,
              bgcolor: formatColor.bgColor,
              borderColor: formatColor.textColor,
              padding: "0 6px",
              width: "auto",
            }}
            variant="outlined"
            label={row.risk_score_details.length}
          />
        </Tooltip>
      )}
    </>
  );
}
